module.exports = __webpack_public_path__ + "img/canada-pneumonia-male.54b8345b.png";